import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { momentFormat } from '@/utils/utils'
import { CooperationAgreement, FranchiseePageResult, IFranchiseeSearchItem, intentionService } from '../intention/intentionService'
import { IMapInfo } from '@/components/YHChooseMap'

export const useJoinCooperate = createModel(function () {
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<FranchiseePageResult[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IFranchiseeSearchItem>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<FranchiseePageResult[]>([])
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    },[pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage =  pgCfgRef.current, searchValue: IFranchiseeSearchItem = searchParam) => {
        const searchParams = {
            searchItem: {
                ...searchValue,
                status: [
                    "franchisee-status.initiated",
                    "franchisee-status.completed",
                    "franchisee-status.received"
                ]
            },
            pageSize: page?.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{column:'createTime', rule:'DESC'}],
        }
        let { retData } = await intentionService.page(searchParams)
        const { list, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(list)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IFranchiseeSearchItem) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    const initAddFormVal = { disableFlag: true }
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<any>(initAddFormVal)
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<any>({})
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initAddFormVal)
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({})
    }
    const [cooperationAgreementForm, setCooperationAgreementForm] = useState<CooperationAgreement | null>()

    const [defaultMapData, setDefaultMapData] = useState<IMapInfo | null>(null)
    //获取一条详情数据 Api
    const getOne = async (id: string) => {
        let { retData } = await intentionService.one(id)
        let { details, ...formVal } = retData;
        const { md5, fileName, address, longitude, latitude } = formVal
        let fileList: any = []
        if (md5) {
            fileList = [
                {
                    uid: md5,
                    status: 'done',
                    name: fileName,
                    response: {
                        retData: md5,
                    },
                },
            ]
        }
        formVal.fileList = fileList
        setEditFormVal({
            ...formVal,
            createTime: momentFormat(formVal.createTime as string),
        })
        const { cooperationAgreementList } = retData
        if (cooperationAgreementList && cooperationAgreementList?.length > 0) {
            setCooperationAgreementForm(cooperationAgreementList[cooperationAgreementList.length - 1])
        } else {
            setCooperationAgreementForm(null)
        }
        setDefaultMapData({ name: address || '', addr: address || '', longitude: longitude as number , latitude: latitude as number })
    }

    return {
        /***field***/
        editFormVal,
        addFormVal,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        cooperationAgreementForm,
        defaultMapData, 
        /***method***/
       
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updateAddFormVal,
        updateEditFormVal,
        getOne,
        setDefaultMapData,
    }
})

